/**
 * Hausrat Endkundenrechner-API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum HausratSelbstbeteiligung {

    Eur0 = 'Eur0',

    Eur150 = 'Eur150',

    Eur300 = 'Eur300',

    Eur500 = 'Eur500',

    Eur1000 = 'Eur1000'
}

